import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cn from '../../../utils/cn';
import './style.less';

@cn('panel-header')
class PanelHeader extends Component {
    render() {
        const { cn } = this;
        const {
            className,
            children,
            ...rest
        } = this.props;

        return (
            <div className={`${cn()} ${className}`} {...rest}>
                {children}
            </div>
        );
    }
}

PanelHeader.propTypes = {
    /** Дополнительное имя класса */
    className: PropTypes.string,
    children: PropTypes.any.isRequired
};

PanelHeader.defaultProps = {
    className: ''
};

export default PanelHeader;